import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import NewMappingReq from "./NewMappingReq";
import BulkUpload from "./BulkUpload";
import MyRequests from "./MyRequests";
import Confirmation from "./Confirmation";

function DealerMapMakerTabs(props) {
const location = useLocation();
// The request details page hands back the tab it wants opened (Go Back /
// Bulk upload / New request), otherwise the dashboard is the landing tab.
const [activeTab, setActiveTab] = useState(location.state?.activeTab || "dashboard");
const [showConfirmation, setShowConfirmation] = useState(false);
const [confirmationData, setConfirmationData] = useState({});

const handleTabChange = (tab) => {
  setActiveTab(tab);
  if (tab !== "newMap") {
    setShowConfirmation(false);
    setConfirmationData({});
  }
};

    return (
        <div className="dealer-mapping-main">
            <Header title={props.title} portal={""} showUserId />
            <SingleSignOnSideBar />
            <main id="dealermap-main-content">
                <div className="tab-content card-box cl-mapping-tab" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    >
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "dashboard" ? "active" : ""}`}
                                            id="dashboard-tab"
                                            data-toggle="tab"
                                            data-target="#dashboard"
                                            type="button"
                                            role="tab"
                                            aria-controls="dashboard"
                                            aria-selected="true"
                                            onClick={()=> handleTabChange("dashboard")}
                                        >
                                            Dashboard
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "newMap" ? "active" : ""}`}
                                            id="newMap-tab"
                                            data-toggle="tab"
                                            data-target="#newMap"
                                            type="button"
                                            role="tab"
                                            aria-controls="newMap"
                                            aria-selected="false"
                                            onClick={()=> handleTabChange("newMap")}
                                        >
                                            New Mapping Request
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation"  >
                                        <button
                                            className={`nav-link ${activeTab === "bulkUpload" ? "active" : ""}`}
                                            id="bulkUpload-tab"
                                            data-toggle="tab"
                                            data-target="#bulkUpload"
                                            type="button"
                                            role="tab"
                                            aria-controls="bulkUpload"
                                            aria-selected="false"
                                            onClick={()=> handleTabChange("bulkUpload")}
                                        >
                                            Bulk Upload
                                        </button>
                                    </li>
                                    {/* <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "draft" ? "active" : ""}`}
                                            id="draft-tab"
                                            data-toggle="tab"
                                            data-target="#draft"
                                            type="button"
                                            role="tab"
                                            aria-controls="draft"
                                            aria-selected="false"
                                            onClick={()=> handleTabChange("draft")}
                                        >
                                            Draft
                                        </button>
                                    </li> */}
                                </ul>
                            </div>

                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                        {activeTab === "newMap" &&
                                        (showConfirmation ? (
                                            <Confirmation
                                            confirmationData={confirmationData}
                                            // setActiveTab={setActiveTab}
                                            handleTabChange={handleTabChange}
                                            onNewUpload={() => {
                                                setShowConfirmation(false);
                                                setActiveTab("newMap");
                                            }}
                                            />
                                        ) : (
                                            <NewMappingReq
                                            setActiveTab={setActiveTab}
                                            setShowConfirmation={setShowConfirmation}
                                            setConfirmationData={setConfirmationData}
                                            />
                                        ))}
                                        {activeTab === "bulkUpload" && (
                                            <BulkUpload
                                            handleTabChange={handleTabChange}/>
                                        )}
                                         {activeTab === "dashboard" && (
                                            <MyRequests setActiveTab={setActiveTab} />
                                         )}
                                         {activeTab === "draft" && (
                                            <MyRequests setActiveTab={setActiveTab} isDraftTab={true} />
                                         )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default DealerMapMakerTabs;

